import { environment } from '../../environments/environment';

const protocol = environment.protocol;

export const ip = environment.host;
export const url_servicios = protocol + "://" + environment.host + environment.rest;
export const url_servicios_pdf = protocol + "://" + environment.host + '/pdf/';
export const url_inland = protocol + "://" + environment.host_inland + "/";
export const url_moduleCSL = protocol + "://" + environment.host_moduleCSL + "/";
export const url_login_csl = protocol + "://" + environment.host_login_csl + "/";
export const url_form = environment.url_form;
export const systemId = environment.systemId;
export const version = environment.version;

export interface Mensaje {
    mensaje?: string;
    tipo?: number;
}

export const es = {
    firstDayOfWeek: 1,
    dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "viernes", "Sábado"],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
}

export class new_transportista {
    ruc: string;
    usuario: string;
    transaccionDetID: string;
    rucTransportista: string;
    razonSocial: string;
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/domain/publico.ts